import axios from "../../axios-config"

// get all articles
export const fetchAllArticles = async (params) => {
  const res = await axios.get(
    "/articles/v1/articles",
    { params }
  );
  return res.data;
};

// get article by slug
export const fetchArticlesBySlug = async (slug) => {
  const res = await axios.get(
    `/articles/v1/articles/${slug}`
  );
  return res.data;
};

export const fetchFeaturedArticles = async () => {
  const res = await axios.get("/articles/v1/featured-articles");
  return res.data;
};

export const updateFeaturedArticles = async (articleIds) => {
  const res = await axios.put("/articles/v1/featured-articles", {
    articleIds,
  });
  return res.data;
};

export const updateArticle = async (id, data) => {
  const res = await axios.put(`/articles/v1/articles/${id}`, data);
  return res.data;
};
